import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs1 from "./page_us/Solution-US-1/SectionUs1.js";
import { useEffect } from "react";




const PlafondsMursTendus = () =>{
  useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Plafond Rétroéclairé Maroc | Mur Lumineux LED – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Plafonds et murs rétroéclairés LED au Maroc avec UNIK SYSTEM : solutions design avec toile tendue pour hôtels, bureaux et commerces. Ambiance lumineuse moderne."
  );

  setMeta(
    "keywords",
    "plafond retroeclaire maroc, mur lumineux LED maroc, plafond lumineux toile tendue maroc, retroeclairage LED maroc, plafond LED design maroc, mur lumineux decoratif maroc, UNIK SYSTEM retroeclairage"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/plafond-lumineux-led-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Plafond Rétroéclairé Maroc – LED Design | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Mur lumineux et plafond rétroéclairé LED pour un rendu moderne et haut de gamme."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/1Plafond%20tendu%20circulaire%20avec%20%C3%A9clairage%20LED%20int%C3%A9gr%C3%A9,%20design%20architectural%20moderne%20pour%20espace%20professionnel%20%E2%80%93%20UNIK%20SYSTEM.b9d194c056ed2b202e6b.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/plafond-lumineux-led-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Plafond Rétroéclairé Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solutions LED rétroéclairées pour plafonds et murs design."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/1Plafond%20tendu%20circulaire%20avec%20%C3%A9clairage%20LED%20int%C3%A9gr%C3%A9,%20design%20architectural%20moderne%20pour%20espace%20professionnel%20%E2%80%93%20UNIK%20SYSTEM.b9d194c056ed2b202e6b.webp"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste des plafonds rétroéclairés LED et murs lumineux au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Rétroéclairage LED",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Plafond Rétroéclairé LED"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Mur Lumineux LED"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-retro");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-retro";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi un plafond rétroéclairé ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est un plafond avec une source LED cachée derrière une toile pour diffuser une lumière uniforme."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Lumière homogène, design moderne, économie d’énergie et ambiance premium."
        }
      },
      {
        "@type": "Question",
        name: "Où utiliser ce système ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Dans hôtels, bureaux, commerces et espaces résidentiels haut de gamme."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-retro");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-retro";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs1/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;